<template>
  <div :class="['card-banner-wrapper']" @click="item.action">
    <div class="card-banner-container">
      <sub-paragraph :class="['sub-paragraph-container', `${ item.colorTitle }-title`]">
        {{ item.text }}
      </sub-paragraph>
      <div class="logo-container" v-if="item?.isActiveLogo">
        <img :src="getUrlLogo('logo-white')" alt="logo">
      </div>
      <div class="card-banner-content">
        <main-paragraph>
          {{ item.title }}
        </main-paragraph>
        <icon-default :icon="'arrow-white'"/>
      </div>
      <div class="bg-container">
        <img :src="getUrl(item.img)" alt="bg">
      </div>
    </div>
  </div>

</template>

<script>
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import IconDefault from "@/components/shared/IconDefault.vue";
import SubParagraph from "@/components/shared/text/SubParagraph.vue";

export default {
  name: "CardBanner",
  components: {SubParagraph, IconDefault, MainParagraph},
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.card-banner-wrapper {
  overflow: hidden;
  cursor: pointer;
  transition: all .6s ease;
  height: 100%;
  width: 100%;
  .card-banner-container {
    min-width:inherit;
    min-height: inherit;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    position: relative;
    .card-banner-content {
      align-items: center;
      width: 100%;
      left: 0;
      bottom: 0;
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background-color: rgba(var(--color-dark-purple-rgba), .8);
    }
    .sub-paragraph-container {
      z-index: 1;
      position: absolute;
      color: var(--color-dark-purple)
    }
    .logo-container {
      z-index: 1;
      position: absolute;

      & img {
        width: 100%;
        height: 100%;
      }
    }
    .bg-container {
      width: 100%;
    }
  }
}

@media (max-width: 3024px){
  .card-banner-wrapper {
    min-width: 430px;
    max-width: 430px;
    min-height: 250px;
    max-height: 280px;

    .sub-paragraph-container {
      top: 30px;
      left: 20px;
      max-width: 290px;
      font-size: 16px;
    }

    .logo-container {
      width: 68px;
      bottom: 80px;
      left: 20px;
    }

    .card-banner-container {
      .text-content {
        font-size: 16px;
      }
      .card-banner-content {
        padding: 24.5px 20px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 20px;
          padding: 0;
        }
      }
    }
  }
}

@media (max-width: 1920px) {
  .card-banner-wrapper {
    min-width: 370px;
    max-width: 370px;
    min-height: 220px;
    max-height: 254px;

    .sub-paragraph-container {
      top: 24px;
      left: 20px;
      max-width: 250px;
      font-size: 14px;
    }

    .logo-container {
      width: 68px;
      bottom: 82px;
      left: 20px;
    }

    .card-banner-container {
      .text-content {
        font-size: 14px;
      }
      .card-banner-content {
        padding: 23px 20px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 20px;
        }
      }
    }
  }
}
@media (max-width: 1600px) {
  .card-banner-wrapper {
    min-width: 280px;
    max-width: 280px;
    min-height: 170px;
    max-height: 190px;

    .sub-paragraph-container {
      top: 16px;
      left: 12px;
      max-width: 240px;
      font-size: 12px;
    }

    .logo-container {
      width: 50px;
      bottom: 58px;
      left: 12px;
    }

    .card-banner-container {
      .text-content {
        font-size: 12px;
      }
      .card-banner-content {
        padding: 12px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 16px;
          padding: 0;
        }
      }
    }
  }

}
@media (max-height: 800px) {
  .card-banner-wrapper {
    min-width: 236px;
    max-width: 236px;
    min-height: 130px;
    max-height: 150px;

    .sub-paragraph-container {
      top: 14px;
      left: 12px;
      max-width: 176px;
      font-size: 10px;
    }

    .logo-container {
      width: 44px;
      bottom: 53px;
      left: 12px;
    }

    .card-banner-container {
      .text-content {
        font-size: 10px;
      }
      .card-banner-content {
        padding: 12px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 12px;
          padding: 0;
        }
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .card-banner-wrapper {
    min-width: 280px;
    max-width: 280px;
    min-height: 170px;
    max-height: 190px;

    .sub-paragraph-container {
      top: 16px;
      left: 12px;
      max-width: 240px;
      font-size: 12px;
    }

    .logo-container {
      width: 50px;
      bottom: 58px;
      left: 12px;
    }

    .card-banner-container {
      .text-content {
        font-size: 12px;
      }
      .card-banner-content {
        padding: 12px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 16px;
          padding: 0;
        }
      }
    }
  }
}

@media (max-width: 1133px) {
  .card-banner-wrapper {
    min-width: 236px;
    max-width: 236px;
    min-height: 130px;
    max-height: 150px;

    .sub-paragraph-container {
      top: 14px;
      left: 12px;
      max-width: 176px;
      font-size: 10px;
    }

    .logo-container {
      width: 44px;
      bottom: 53px;
      left: 12px;
    }

    .card-banner-container {
      .text-content {
        font-size: 10px;
      }
      .card-banner-content {
        padding: 12px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 12px;
          padding: 0;
        }
      }
    }
  }
}
@media (max-width: 769px) {
  .card-banner-wrapper {
    min-width: 280px;
    max-width: 280px;
    min-height: 170px;
    max-height: 190px;

    .sub-paragraph-container {
      top: 16px;
      left: 12px;
      max-width: 240px;
      font-size: 12px;
    }

    .logo-container {
      width: 50px;
      bottom: 58px;
      left: 12px;
    }


    .card-banner-container {
      .text-content {
        max-width: 80%;
        font-size: 12px;
      }
      .card-banner-content {
        padding: 12px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 16px;
          padding: 0;
        }
      }
    }
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .card-banner-wrapper {
    min-width: 800px;
    max-width: 800px;
    min-height: 460px;
    max-height: 520px;


    .sub-paragraph-container {
      top: 40px;
      left: 30px;
      max-width: 436px;
      font-size: 24px;
    }


    .logo-container {
      width: 121px;
      bottom: 160px;
      left: 30px;
    }

    .card-banner-container {
      .text-content {
        font-size: 30px;
      }
      .card-banner-content {
        padding: 48px 30px;
        backdrop-filter: blur(10px);

        .icon-container {
          --size-icon: 32px;
          padding: 0;
        }
      }
    }
  }
}


</style>